import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { OverlayTrigger, ProgressBar, Tooltip } from "react-bootstrap";
import { FiEdit3, FiEye } from "react-icons/fi";
import toastr from "toastr";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { confirmAlert } from "react-confirm-alert";
import { CustomToggleList } from "app/Components/BootstrapTable/SearchBootstrapTable";
import ToolkitProvider, {
  Search,
  ColumnToggle,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { FiEdit } from "react-icons/fi";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import { deleteTask } from "app/_services/ehs/ehsEventScheduleServices";
import {
  getAllEventSchedules,
  getAllTaskRevert,
} from "app/_services/ehs/ehsEventScheduleServices";
import moment from "moment";
import { SetPermission } from "app/Components/SetPermission/Permissions";
import { getOhseStatusClass, MEETING_STATUS, ohseFilterFields } from "./CONSTANT";
import localStorageService from "app/services/localStorageService";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  customColumnMatch,
  formatDDMMYYYYbyYYYYMMDD,
  paginationOptionsObj,
} from "app/_helpers/helper";
import {
  DDMMYYYYHHMMAFormat,
  isBetween,
  YYYYMMDDFormat,
  DDMMYYYYFormat,
} from "app/_helpers/dateHelper";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import OHSEFilter from "./Component/OHSEFilter";
import { useForm } from "app/_helpers/hooks";
import { validateRowFilter } from "../IncidentManagement/CONSTANTS";
import { ACTIVE_MODULE } from "app/_constants/constant";
import { useDispatch, useSelector } from "react-redux";
import { filterActionAdd } from "../TrainingManagement/Assign/ReducerForAssign";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
import { TASK_STATUS_VIEW } from "./CONSTANT";
import { FaRegTrashAlt } from "react-icons/fa";
import { getTaskStatusClass } from "./CONSTANT";
import { GiReturnArrow } from "react-icons/gi";

const { SearchBar } = Search;
const { ToggleList } = ColumnToggle;

function MyApprovalActionOHSE({
  match: {
    params: { siteId },
  },
}) {
  const [tab, setTab] = useState(1);
  const dispatchFunction = useDispatch();
  const [incidents, setIncidents] = useState([]);
  const [incidentsFilter, setIncidentsFilter] = useState([]);
  const [incidentsTable, setIncidentsTable] = useState([]);
  // const [filterForm, onChangeFilter, setFilterForm] = useForm({}, incidentFilterFields);
  const [tabCount, setTabCount] = useState({});
  const [taskRevert, setTaskRevert] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [tableOHSEList, setTableOHSEList] = useState([]);
  const [filterForm, onChangeFilter, setFilterForm] = useForm({}, ohseFilterFields);
  // const [showFilter, setShowFilter] = useState(true);
  const [searchFilter, setSearchFilter] = useState();
  const filterStatus = useSelector((state) => state.filterReducerTraining);
  const [loading, setLoading] = useState(true);

  const onSearchFilter = (props) => {
    let value = props?.searchProps?.searchText;
    if (searchFilter?.search !== props?.searchProps?.searchText) setSearchFilter(value);
  };

  useEffect(() => {
    dispatchFunction(filterActionAdd({ myActionOhse: searchFilter }));
  }, [searchFilter]);

  const onReset = () => setFilterForm({});

  const showEditIcon = useCallback((row) => {
    let showEdit = false;
    let tabNumber = null;
    const permissions = localStorageService.getItem("permissions");

    if (
      permissions[row?.event?.scheduler] &&
      (row.eventStatus === MEETING_STATUS.scheduled ||
        row.eventStatus === MEETING_STATUS.draft)
    ) {
      showEdit = true;
      tabNumber = 1;
    }
    if (
      permissions[row?.event?.reviewer] &&
      row.eventStatus === MEETING_STATUS.inProgress &&
      row.reviewer === 1
    ) {
      showEdit = true;
      tabNumber = 2;
    }
    if (
      permissions[row?.event?.approver] &&
      (row.eventStatus === MEETING_STATUS.planned ||
        (row.eventStatus === MEETING_STATUS.inProgress &&
          (row.reviewer !== 1 || row?.isReviewed === 1)) ||
        row.eventStatus === MEETING_STATUS.reviewed)
    ) {
      showEdit = true;
      tabNumber = 3;
    }

    return { showEdit, tabNumber };
  }, []);

  const sortableColumn = [
    {
      dataField: "sid",
      text: "S.No.",
      sort: true,
    },

    {
      dataField: "scheduleId",
      text: "OHSE Review ID",
      sort: true,
      formatter: (scheduleId, row) => (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">View</Tooltip>}
        >
          <Link
            className="icons text-cyanBlue"
            to={
              (row?.eventStatus === MEETING_STATUS.draft ||
              row?.eventStatus === MEETING_STATUS.planned
                ? "/health-safety-and-environment/audits-meetings/scheduled-event/view/"
                : "/health-safety-and-environment/audits-meetings/scheduled-event/meeting/view/") +
              row?.id
            }
          >
            {scheduleId}
          </Link>
        </OverlayTrigger>
      ),
    },
    {
      dataField: "type",
      text: "Review Type",
      sort: true,
    },
    {
      dataField: "site",
      text: "Location",
      sort: true,
      formatter: (site) => `${site?.name}`,
    },
    {
      dataField: "venue",
      text: "Venue",
      sort: true,
    },
    {
      dataField: "date",
      text: "Review Date & Time",
      sort: true,
      formatter: (date) => DDMMYYYYHHMMAFormat(date),
    },
    {
      dataField: "progressStatus",
      text: "Progress",
      sort: true,
      formatter: (row, data) => {
        return (
          <>
            {data?.isExecuted == true ? (
              data?.progressCompleteTask !== 0 && data?.progressTotalTask !== 0 ? (
                <ProgressBar
                  className="progress mb-3 mt-2"
                  now={Number(data?.progressCompleteTask / data?.progressTotalTask) * 100}
                  striped
                  animated
                  label={`${
                    Number(data?.progressCompleteTask / data?.progressTotalTask) * 100
                  }%`}
                  variant="primary"
                ></ProgressBar>
              ) : (
                "N/A"
              )
            ) : (
              "N/A"
            )}
          </>
        );
      },
    },
    {
      dataField: "eventStatusView",
      text: "Status",
      formatter: (status, row) => {
        return <div className={getOhseStatusClass(row?.eventStatus)}>{status}</div>;
      },
    },
    {
      dataField: "createdAt",
      text: "Time Stamp",
      sort: true,
      formatter: (createdAt, row) => {
        return DDMMYYYYHHMMAFormat(createdAt);
      },
    },

    {
      dataField: "id",
      text: "Action",
      formatter: (id, row) => {
        return (
          <div className="actionIconsGroup">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">Views</Tooltip>}
            >
              <Link
                to={
                  (siteId ? `/sites/${siteId}` : "") +
                  (row?.eventStatus === MEETING_STATUS.draft ||
                  row?.eventStatus === MEETING_STATUS.planned
                    ? "/health-safety-and-environment/audits-meetings/scheduled-event/view/"
                    : "/health-safety-and-environment/audits-meetings/scheduled-event/meeting/view/") +
                  id
                }
                className="icons text-cyanBlue"
              >
                <FiEye />
              </Link>
            </OverlayTrigger>
            {(row.eventStatus === MEETING_STATUS.planned ||
              (row.eventStatus === MEETING_STATUS.inProgress &&
                (row.reviewer !== 1 || row?.isReviewed === 1)) ||
              row.eventStatus === MEETING_STATUS.reviewed) && (
              <SetPermission
                permission={row?.event?.approver}
                data={
                  <>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-top">Edit</Tooltip>}
                    >
                      <Link
                        to={
                          (row?.eventStatus === MEETING_STATUS.planned ||
                          row?.eventStatus === MEETING_STATUS.draft
                            ? "/health-safety-and-environment/audits-meetings/scheduled-event/edit/"
                            : "/health-safety-and-environment/audits-meetings/scheduled-event/meeting/edit/") +
                          id
                        }
                        className="icons text-cyanBlue"
                      >
                        <FiEdit3 />
                      </Link>
                    </OverlayTrigger>
                  </>
                }
              />
            )}

            {(row.eventStatus === MEETING_STATUS.scheduled ||
              row.eventStatus === MEETING_STATUS.draft) && (
              <SetPermission
                permission={row?.event?.scheduler}
                data={
                  <>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-top">Edit</Tooltip>}
                    >
                      <Link
                        to={
                          (row?.eventStatus === MEETING_STATUS.planned ||
                          row?.eventStatus === MEETING_STATUS.draft
                            ? "/health-safety-and-environment/audits-meetings/scheduled-event/edit/"
                            : "/health-safety-and-environment/audits-meetings/scheduled-event/meeting/edit/") +
                          id
                        }
                        className="icons text-cyanBlue"
                      >
                        <FiEdit3 />
                      </Link>
                    </OverlayTrigger>
                  </>
                }
              />
            )}

            {row.eventStatus === MEETING_STATUS.inProgress && row.reviewer === 1 && (
              <SetPermission
                permission={row?.event?.reviewer}
                data={
                  <>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-top">Edit</Tooltip>}
                    >
                      <Link
                        to={
                          "/health-safety-and-environment/audits-meetings/scheduled-event/meeting/edit/" +
                          id
                        }
                        className="icons text-cyanBlue"
                      >
                        <FiEdit3 />
                      </Link>
                    </OverlayTrigger>
                  </>
                }
              />
            )}
            {tab === 4 && (
              <>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top">Update</Tooltip>}
                >
                  <Link
                    to={{
                      pathname:
                        (siteId ? `/sites/${siteId}` : "") +
                        "/health-safety-and-environment/audits-meetings/update-task/" +
                        row.id,
                      state: { ownerId: row?.taskOwnerId },
                    }}
                    className="icons text-cyanBlue"
                  >
                    <FiEdit />
                  </Link>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                >
                  <span
                    onClick={() => deleteRow(row?.id, { ownerId: row?.taskOwnerId })}
                    className="icons text-danger pointer"
                  >
                    <FaRegTrashAlt />
                  </span>
                </OverlayTrigger>
              </>
            )}
          </div>
        );
      },
    },
  ];
  const revertColumn = [
    {
      dataField: "sid",
      text: "S.No.",
      sort: true,
    },
    {
      dataField: "taskId",
      text: "Task ID",
      sort: true,
      formatter: (taskId, row) => (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">View</Tooltip>}
        >
          <Link
            className="icons text-cyanBlue"
            to={
              (siteId ? `/sites/${siteId}` : "") +
              "/health-safety-and-environment/audits-meetings/view-owner/" +
              row.id
            }
          >
            {taskId}
          </Link>
        </OverlayTrigger>
      ),
    },
    {
      dataField: "scheduleId",
      text: "OHSE Review ID",
      sort: true,
      formatter: (scheduleId, row) => row?.ohseData?.scheduleId,
    },
    {
      dataField: "locationName",
      text: "Location Name",
      sort: true,
    },
    {
      dataField: "taskDescription",
      text: "Task Description",
      sort: true,
      classes: "text-wrap",
    },
    {
      dataField: "ownerData",
      text: "Task Owner",
      sort: true,
      formatter: (id, row) => {
        console.log("row?.ownerData", row);
        return `${row?.ownerData}`;
      },
    },
    {
      dataField: "taskDueDate",
      text: "Due Date",
      sort: true,
      formatter: (rowContent) => DDMMYYYYFormat(rowContent),
    },
    {
      dataField: "completionDate",
      text: "Completion Date",
      sort: true,
      formatter: (completionDate) =>
        completionDate ? DDMMYYYYHHMMAFormat(completionDate) : "In Progress",
    },
    {
      dataField: "task_status",
      text: "Status",
      formatter: (status, row) => {
        return (
          <div
            className={
              !row?.isTaskRevert
                ? getTaskStatusClass(status)
                : "bg-primary text-white rounded text-center"
            }
          >
            {!row?.isTaskRevert ? (
              status
            ) : (
              <>
                Returned Task <GiReturnArrow className="ml-2" size={18} />
              </>
            )}
          </div>
        );
      },
    },
    {
      dataField: "createdAt",
      text: "Time Stamp",
      sort: true,
      formatter: (createdAt, row) => {
        return DDMMYYYYHHMMAFormat(createdAt);
      },
    },
    {
      dataField: "id",
      text: "Action",
      formatter: (id, row) => {
        return (
          <div className="actionIconsGroup">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">View</Tooltip>}
            >
              <Link
                to={{
                  pathname:
                    (siteId ? `/sites/${siteId}` : "") +
                    "/health-safety-and-environment/audits-meetings/view-owner/" +
                    row.id,
                  state: { ownerId: row?.ownerData?.ownerId },
                }}
                className="icons text-cyanBlue"
              >
                <FiEye />
              </Link>
            </OverlayTrigger>

            {tab === 4 && (
              <>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top">Update</Tooltip>}
                >
                  <Link
                    to={{
                      pathname:
                        (siteId ? `/sites/${siteId}` : "") +
                        "/health-safety-and-environment/audits-meetings/update-task/" +
                        row.id,
                      state: { ownerId: row?.taskOwnerId },
                    }}
                    className="icons text-cyanBlue"
                  >
                    <FiEdit />
                  </Link>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                >
                  <span
                    onClick={() => deleteRow(row?.id, { ownerId: row?.taskOwnerId })}
                    className="icons text-danger pointer"
                  >
                    <FaRegTrashAlt />
                  </span>
                </OverlayTrigger>
              </>
            )}
          </div>
        );
      },
    },
  ];
  /*************** useEffect *********************/
  //  set only edit data

  const rowStyle = (row) => {
    if (row?.isTaskRevert && tab !== 4) {
      return { backgroundColor: "#d2ced6" };
    }
  };
  const deleteRow = (id, obj) => {
    confirmAlert({
      title: "Delete Task",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            let response = await deleteTask(id, obj);

            if (!response?.status) return toastr.info(response?.message);

            toastr.info(response?.message || "Deleted Successfully!");
            taskRevertList();
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const taskRevertList = () => {
    getAllTaskRevert().then((response) => {
      if (!response?.status) return;
      const finalList = [];
      const revertList = response?.data.map((d) =>
        d?.taskOwners.map((obj) => {
          const objOwner = {
            ...d,
            // ownerData: obj,
            ownerData: obj?.userData?.firstName + " " + obj?.userData?.lastName,
            eventId: d?.ohseData?.eventId,
            siteId: d?.ohseData?.siteId,
            scheduleId: d?.ohseData?.scheduleId,
            meetingLabel: d?.ohseData?.event?.meetingLabel,
            task_status: !obj?.reverted
              ? obj?.isTaskCompleted
                ? TASK_STATUS_VIEW.completed
                : TASK_STATUS_VIEW.open
              : "Returned",
            isTaskRevert: obj?.reverted,
            taskOwnerId: obj?.ownerId,
            locationName: d?.ohseData?.site?.name,
          };
          finalList.push(objOwner);
        })
      );
      setTaskRevert(finalList);
    });
  };

  useEffect(() => {
    const obj = {};
    setIncidentsTable(
      incidents.filter((row) => {
        const { showEdit, tabNumber } = showEditIcon(row);
        if (!obj.hasOwnProperty(tabNumber)) {
          obj[tabNumber] = 1;
        } else {
          obj[tabNumber] += 1;
        }
        return showEdit ? true : false;
      })
    );
    setTabCount(obj);
  }, [incidents, showEditIcon]);
  const fetchData = async () => {
    const response = await getAllEventSchedules();
    if (!response?.data) {
      // Handle the case where data is not received
      setLoading(false);
      return;
    }
    setIncidents(
      response.data.map((inc, idx) => ({
        ...inc,
        sid: idx + 1,
      }))
    );
    setLoading(false);
  };
  // fetch table data
  useEffect(() => {
    fetchData();
    taskRevertList();
  }, []);

  // set data by tab
  useEffect(() => {
    const permissions = localStorageService.getItem("permissions");

    setIncidentsFilter(
      tab !== 4
        ? incidentsTable?.filter?.((row) => {
            let showEditIcon = false;

            if (
              tab === 1 &&
              permissions[row?.event?.scheduler] &&
              (row.eventStatus === MEETING_STATUS.scheduled ||
                row.eventStatus === MEETING_STATUS.draft)
            ) {
              showEditIcon = true;
            }
            if (
              tab === 2 &&
              permissions[row?.event?.reviewer] &&
              row.eventStatus === MEETING_STATUS.inProgress &&
              row.reviewer === 1
            ) {
              showEditIcon = true;
            }
            if (
              tab === 3 &&
              permissions[row?.event?.approver] &&
              (row.eventStatus === MEETING_STATUS.planned ||
                (row.eventStatus === MEETING_STATUS.inProgress &&
                  (row.reviewer !== 1 || row?.isReviewed === 1)) ||
                row.eventStatus === MEETING_STATUS.reviewed)
            ) {
              showEditIcon = true;
            }
            return showEditIcon;
          })
        : taskRevert
    );
  }, [incidentsTable, tab, taskRevert]);

  useEffect(() => {
    setTableOHSEList(
      incidentsFilter?.filter?.((data) => {
        let flag = true;
        if (filterForm?.startDate && filterForm?.endDate) {
          flag = isBetween(
            YYYYMMDDFormat(data.createdAt),
            YYYYMMDDFormat(filterForm.startDate),
            YYYYMMDDFormat(filterForm.endDate)
          );
        }

        if (flag) flag = validateRowFilter(filterForm, data);
        return flag;
      })
    );
  }, [filterForm, incidentsFilter]);

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "OHSE Review",
            path: "/health-safety-and-environment/audits-meetings",
          },
          { name: "My Approval Actions" },
        ]}
        module={ACTIVE_MODULE.ohse}
      />
      <div className="card p-3">
        <div className="simple-card-title cardCustomHeader">
          <h3 class="text-capitalize mb-1">My Approval Actions</h3>
          {tab !== 4 ? <FilterBtn setShowFilter={setShowFilter} /> : ""}
          {/* <button
          className="btn btn-outline-primary filterBtn"
          onClick={() => {
            setShowFilter((prev) => !prev);
          }}
        >
          <i className="i-Filter-2"></i>Filter
        </button> */}

          <BackBtn url={"/health-safety-and-environment/audits-meetings"} />
        </div>

        <div className="healthSafetyEnvironmentWrapper EHS_module_tabber">
          <div className="hseMenuLinks card">
            <a
              href
              onClick={() => setTab(1)}
              className={`pointer${tab === 1 ? " active" : ""}`}
            >
              Scheduler ({tabCount[1] || 0})
            </a>
            <a
              href
              onClick={() => setTab(2)}
              className={`pointer${tab === 2 ? " active" : ""}`}
            >
              Reviewer ({tabCount[2] || 0})
            </a>
            <a
              href
              onClick={() => setTab(3)}
              className={`pointer${tab === 3 ? " active" : ""}`}
            >
              Approver ({tabCount[3] || 0})
            </a>
            {taskRevert?.length ? (
              <a
                href
                onClick={() => setTab(4)}
                // style={{pointerEvents: 'none'}}
                className={`pointer${tab === 4 ? " active" : ""}`}
              >
                Returned Tasks ({taskRevert?.length})
              </a>
            ) : (
              ""
            )}
          </div>
        </div>

        {showFilter && tab !== 4 && (
          <OHSEFilter
            fields={ohseFilterFields}
            setForm={setFilterForm}
            form={filterForm}
            onChange={onChangeFilter}
            onReset={onReset}
          />
        )}

        <ToolkitProvider
          striped
          keyField="id"
          data={tableOHSEList?.map((d, idx) => ({ ...d, sid: idx + 1 }))}
          columns={tab === 4 ? revertColumn : sortableColumn}
          columnToggle
          search={{
            onColumnMatch: customColumnMatch,
            searchFormatted: true,
            defaultSearch: filterStatus?.myActionOhse,
          }}
        >
          {(props) => {
            return (
              <>
                {onSearchFilter(props)}
                <div className="d-flex align-items-center justify-content-between pb-3 mt-3">
                  <SearchBar {...props.searchProps} className="mb-0" />
                  <div className="d-flex hideShow mr-4">
                    <div class="hideShowColumnDiv">
                      <h3 class="hideShowColumn">Columns</h3>
                    </div>
                    <CustomToggleList
                      {...props.columnToggleProps}
                      tableKey="myApprovalActionOHSE"
                    />
                  </div>
                </div>
                <div className="material-master-table incidentTable">
                  {!loading ? (
                    <BootstrapTable
                      // rowStyle={rowStyle}
                      {...props.baseProps}
                      bootstrap4
                      noDataIndication={"Table is empty"}
                      pagination={paginationFactory({
                        ...paginationOptionsObj,
                        totalSize: Array.isArray(tableOHSEList)
                          ? tableOHSEList.length
                          : 0,
                      })}
                    />
                  ) : (
                    <NetZeroLoader />
                  )}
                </div>
              </>
            );
          }}
        </ToolkitProvider>
      </div>
    </>
  );
}

export default MyApprovalActionOHSE;
